import React from "react";
// a solution that works across all browsers and avoids relying
// solely on window.open, we can use an anchor (<a>) element instead.
// The anchor tag ensures proper redirection behavior across browsers,
// including those with restrictions on window.open.
// Here's an updated version of the AdClickableLink component:
import "./adClickableLink.scss";

const AdClickableLink = ({ url, onClick, label = "Visit Advertiser's Website" }) => {
  if (!url) return null; // Prevent rendering if there is no URL

  const handleClick = async (e) => {
    e.preventDefault(); // Prevent the default <a> behavior

    try {
      // Record the ad click via the provided onClick callback
      if (onClick) {
        await onClick();
      }

      // Open the URL in a new browser tab
      window.open(url, "_blank");
    } catch (error) {
      console.error("Redirection error:", error);
      // Optionally, display an error message to the user here
    }
  };

  return (
    <div className="ad-clickable-link">
      <a
        href={url} // Keep href for SEO and accessibility
        onClick={handleClick} // Our custom click handler
        className="visit-website-btn"
      >
        {label}
      </a>
    </div>
  );
};

export default AdClickableLink;
